import { BaseNotification } from '../helpers/types';
import { useNotificationStore } from '../store/useNotificationStore';
import { INotificationService } from './INotificationService';

export class NotificationServiceImpl implements INotificationService {
  private notificationStore: typeof useNotificationStore;

  public constructor(notificationStore: typeof useNotificationStore) {
    this.notificationStore = notificationStore;
  }

  public addNotification(notification: BaseNotification): void {
    this.notificationStore.getState().addNotification(notification);
  }

  public setPanelState(open: boolean): void {
    this.notificationStore.getState().setPanelOpen(open);
  }
}
